<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Activity`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7751 3.59785C16.0862 3.08799 17.5 4.05514 17.5 5.46186V18.5382C17.5 19.9449 16.0862 20.912 14.7751 20.4022L7.96028 17.752L3.07123 17.9262C1.93945 17.9665 1 17.06 1 15.9275V8.06298C1 6.93412 1.93366 6.02896 3.06197 6.06394L8 6.21701V6.23262L14.7751 3.59785ZM15.5 18.5382L8 15.6215V8.37853L15.5 5.46186L15.5 18.5382ZM20 7.50002C19.4477 7.50002 19 7.94773 19 8.50002C19 9.0523 19.4477 9.50002 20 9.50002H21C21.5523 9.50002 22 9.0523 22 8.50002C22 7.94773 21.5523 7.50002 21 7.50002H20ZM18.5 12.5C18.5 11.9477 18.9477 11.5 19.5 11.5H22C22.5523 11.5 23 11.9477 23 12.5C23 13.0523 22.5523 13.5 22 13.5H19.5C18.9477 13.5 18.5 13.0523 18.5 12.5ZM20 15.5C19.4477 15.5 19 15.9477 19 16.5C19 17.0523 19.4477 17.5 20 17.5H21C21.5523 17.5 22 17.0523 22 16.5C22 15.9477 21.5523 15.5 21 15.5H20Z"/></svg>
</template>
<script>

export default {
  name: 'IconActivity',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
